export default {"src":"/_next/static/media/goat-spins-text-banner-2-desk.40670be1.svg","height":273,"width":590,"blurWidth":0,"blurHeight":0};